import { render, staticRenderFns } from "./MaterialSuggestions.vue?vue&type=template&id=0a52bb15&scoped=true&"
import script from "./MaterialSuggestions.vue?vue&type=script&lang=js&"
export * from "./MaterialSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSuggestions.vue?vue&type=style&index=0&id=0a52bb15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52bb15",
  null
  
)

export default component.exports